import React from 'react';

const STATUS_CONFIG: Record<string, { label: string; bg: string; text: string; darkBg: string; darkText: string }> = {
  RECEBIDA:     { label: 'Recebida',     bg: 'bg-blue-100',   text: 'text-blue-700',   darkBg: 'dark:bg-blue-950/40',   darkText: 'dark:text-blue-300' },
  EM_ANALISE:   { label: 'Em Análise',   bg: 'bg-amber-100',  text: 'text-amber-700',  darkBg: 'dark:bg-amber-950/40',  darkText: 'dark:text-amber-300' },
  EM_ANDAMENTO: { label: 'Em Andamento', bg: 'bg-violet-100', text: 'text-violet-700', darkBg: 'dark:bg-violet-950/40', darkText: 'dark:text-violet-300' },
  APROVADA:     { label: 'Aprovada',     bg: 'bg-emerald-100',text: 'text-emerald-700',darkBg: 'dark:bg-emerald-950/40',darkText: 'dark:text-emerald-300' },
  RESOLVIDA:    { label: 'Resolvida',    bg: 'bg-green-100',  text: 'text-green-700',  darkBg: 'dark:bg-green-950/40',  darkText: 'dark:text-green-300' },
  ENCAMINHADA:  { label: 'Encaminhada',  bg: 'bg-indigo-100', text: 'text-indigo-700', darkBg: 'dark:bg-indigo-950/40', darkText: 'dark:text-indigo-300' },
  ARQUIVADA:    { label: 'Arquivada',    bg: 'bg-slate-100',  text: 'text-slate-600',  darkBg: 'dark:bg-slate-800',     darkText: 'dark:text-slate-400' },
  INDEFERIDA:   { label: 'Indeferida',   bg: 'bg-red-100',    text: 'text-red-700',    darkBg: 'dark:bg-red-950/40',    darkText: 'dark:text-red-300' },
  EXCLUIDA:     { label: 'Excluída',     bg: 'bg-slate-100',  text: 'text-slate-500',  darkBg: 'dark:bg-slate-800',     darkText: 'dark:text-slate-500' },
};

interface StatusBadgeProps {
  status: string;
  size?: 'xs' | 'sm' | 'md';
  dot?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'sm', dot = false }) => {
  const cfg = STATUS_CONFIG[status] ?? {
    label: status, bg: 'bg-slate-100', text: 'text-slate-600', darkBg: 'dark:bg-slate-800', darkText: 'dark:text-slate-400'
  };

  const sizeClasses = {
    xs: 'text-[9px] px-1.5 py-0.5',
    sm: 'text-[10px] px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
  }[size];

  return (
    <span className={`inline-flex items-center gap-1 font-bold rounded-full ${cfg.bg} ${cfg.text} ${cfg.darkBg} ${cfg.darkText} ${sizeClasses}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${cfg.text.replace('text-', 'bg-')}`} />}
      {cfg.label}
    </span>
  );
};

const PRIORITY_CONFIG: Record<string, { label: string; cls: string }> = {
  URGENTE: { label: '🔴 Urgente', cls: 'priority-urgente' },
  ALTA:    { label: '🟠 Alta',    cls: 'priority-alta' },
  MEDIA:   { label: '🔵 Média',   cls: 'priority-media' },
  BAIXA:   { label: '🟢 Baixa',   cls: 'priority-baixa' },
};

interface PriorityBadgeProps {
  priority: string;
  size?: 'xs' | 'sm' | 'md';
  compact?: boolean;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, size = 'sm', compact = false }) => {
  const cfg = PRIORITY_CONFIG[priority?.toUpperCase()] ?? { label: priority ?? 'Média', cls: 'priority-media' };

  const sizeClasses = {
    xs: 'text-[9px] px-1.5 py-0.5',
    sm: 'text-[10px] px-2 py-0.5',
    md: 'text-xs px-2.5 py-1',
  }[size];

  if (compact) {
    const emoji = cfg.label.split(' ')[0];
    return <span title={cfg.label} className="text-sm">{emoji}</span>;
  }

  return (
    <span className={`inline-flex items-center font-bold rounded-full ${cfg.cls} ${sizeClasses}`}>
      {cfg.label}
    </span>
  );
};
